import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../queryClient';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';
import { usePreferencesMutation } from './usePreferencesMutation';

const MUTATION_KEY = ['update-preferences-metrics'];

const updateFunction = async (metrics: string[]) => {
  await preferencesApi.setMetricsSettings(metrics);
  queryClient.setQueryData<string[]>(preferencesQueryKey.metrics(), () => metrics);
};

export const useMetricsPreferencesMutation = (onClose: () => void) => {
  return usePreferencesMutation({ mutationKey: MUTATION_KEY, updateFunction, onClose });
};

export const useUpdateMetricsMutation = () => {
  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn: updateFunction,
  });
};
